// The plans and credit packs with their live Stripe prices (GET /payments/plans, billing review
// P5.8). The prices used to be typed into this client twice, once for the personal plan page
// and once for the organization billing tab, so a price changed in Stripe would have been
// charged at the new amount while both pages still showed the old one.
import { useEffect, useState } from "react";
import apiClient from "api/apiClient";

let pending = null;

const loadCatalog = () => {
  if (!pending) {
    pending = apiClient
      .get(`${process.env.REACT_APP_BASE_URL}/payments/plans`)
      .then((res) => res.data)
      .catch((error) => {
        pending = null; // let a later mount try again
        throw error;
      });
  }
  return pending;
};

/** { catalog: { plans, packs } | null, error: boolean } */
export const useBillingCatalog = () => {
  const [state, setState] = useState({ catalog: null, error: false });
  useEffect(() => {
    let alive = true;
    loadCatalog()
      .then((catalog) => alive && setState({ catalog, error: false }))
      .catch(() => alive && setState({ catalog: null, error: true }));
    return () => {
      alive = false;
    };
  }, []);
  return state;
};

const money = (amount, currency) =>
  `${currency || "CAD"} $${Number(amount).toLocaleString("en-CA", { maximumFractionDigits: 2 })}`;

/** "CAD $700/month", "CAD $250", or a placeholder while loading / when unavailable. */
export const formatCatalogPrice = (item, { error = false } = {}) => {
  if (!item || !Number.isFinite(Number(item.amount))) return error ? "Price unavailable" : "…";
  return `${money(item.amount, item.currency)}${item.interval ? `/${item.interval}` : ""}`;
};

/**
 * The saving a larger pack gives against the smallest pack's price per credit, in whole
 * percent, or 0. Derived from the prices, so it cannot disagree with them.
 */
export const packDiscountPercent = (pack, packs = []) => {
  const perCredit = (p) => Number(p?.amount) / Number(p?.credits);
  const base = packs.reduce((best, p) => (perCredit(p) > perCredit(best || p) ? p : best || p), null);
  if (!pack || !base || !(perCredit(base) > 0)) return 0;
  return Math.max(0, Math.round((1 - perCredit(pack) / perCredit(base)) * 100));
};
